<template>
    <div>
      <h2>Super Admin Management</h2>
  
      <label>Email:</label>
      <input v-model="email" type="email" required placeholder="Enter user email" />
  
      <button @click="assignSuperAdmin" :disabled="loading">
        {{ loading ? "Assigning..." : "Set as Super Admin" }}
      </button>
      
      <p v-if="message" class="success">{{ message }}</p>
      <p v-if="errorMessage" class="error">{{ errorMessage }}</p>
    </div>
  </template>
  
  <script>
  import { auth } from "../firebase"; // Import the listener
  import {  onAuthStateChanged } from "firebase/auth";// getIdToken
  import { getFunctions, httpsCallable } from "firebase/functions";
  
  export default {
    data() {
      return {
        email: "",
        loading: false,
        message: "",
        errorMessage: "",
      };
    },
    methods: {
        async initializeFirebase() {
         this.auth = auth;
       
        },
        async checkAuthState() {
      onAuthStateChanged(this.auth, async (user) => {
        if (user) {
          const idTokenResult = await user.getIdTokenResult(true);
          console.log("🛠️ User Role:", idTokenResult.claims.role);
          console.log("🛠️ Assigned Shop:", idTokenResult.claims.shopId);
          this.email = user.email ;
          
          
        } else {  
          console.log("User not authenticated. Redirecting to login...");
          this.$router.push("/"); // Use Vue Router instead of window.location.href
        }
      });
    },
      async assignSuperAdmin() {
        if (!this.email) {
          alert("❌ Please provide an email.");
          return;
        }
  
        try {
          this.loading = true;
          this.message = "";
          this.errorMessage = "";
  
          // ✅ Call Firebase Cloud Function
          const functions = getFunctions();
          const setSuperAdmin = httpsCallable(functions, "setSuperAdmin");
  
          const response = await setSuperAdmin({ email: this.email });
  
          this.message = response.data.message;
        } catch (error) {
          console.error("❌ Error assigning Super Admin:", error);
          this.errorMessage = "❌ Failed to assign Super Admin.";
        } finally {
          this.loading = false;
        }
      },
    },
    async mounted() {
        await this.initializeFirebase();
        await this.checkAuthState();
       
    },
  };
  </script>
  
  <style scoped>
  .success {
    color: green;
    font-weight: bold;
  }
  .error {
    color: red;
    font-weight: bold;
  }
  button {
    background-color: #007bff;
    color: white;
    padding: 10px;
    border: none;
    cursor: pointer;
    margin-top: 10px;
  }
  button:disabled {
    background-color: #ccc;
  }
  </style>
  